/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyTemperature } from "./CompanyTemperature";
import {
  CompanyTemperatureFromJSON,
  CompanyTemperatureFromJSONTyped,
  CompanyTemperatureToJSON,
  CompanyTemperatureToJSONTyped,
} from "./CompanyTemperature";
import type { AddLabelsToCompany } from "./AddLabelsToCompany";
import {
  AddLabelsToCompanyFromJSON,
  AddLabelsToCompanyFromJSONTyped,
  AddLabelsToCompanyToJSON,
  AddLabelsToCompanyToJSONTyped,
} from "./AddLabelsToCompany";
import type { CountryCode } from "./CountryCode";
import {
  CountryCodeFromJSON,
  CountryCodeFromJSONTyped,
  CountryCodeToJSON,
  CountryCodeToJSONTyped,
} from "./CountryCode";

/**
 *
 * @export
 * @interface EditCompanyInput
 */
export interface EditCompanyInput {
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  companyName: string;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  phone: string;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  billingAddressLine: string;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  billingCity: string;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  billingState: string;
  /**
   *
   * @type {CountryCode}
   * @memberof EditCompanyInput
   */
  billingCountry?: CountryCode | null;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  billingPostalCode: string;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  leadSource: string;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  leadSourceNote?: string | null;
  /**
   *
   * @type {CompanyTemperature}
   * @memberof EditCompanyInput
   */
  temperature?: CompanyTemperature | null;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  shipmentFrequency?: string | null;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  shipmentFrequencyNote?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof EditCompanyInput
   */
  associatedProfessionalDomain: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof EditCompanyInput
   */
  knownGroupEmailAddresses: Array<string>;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  invoiceAuditNotes: string;
  /**
   *
   * @type {boolean}
   * @memberof EditCompanyInput
   */
  apiAccessEnabled: boolean;
  /**
   *
   * @type {AddLabelsToCompany}
   * @memberof EditCompanyInput
   */
  addLabelsToCompany: AddLabelsToCompany;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  assignedTo?: string | null;
  /**
   *
   * @type {string}
   * @memberof EditCompanyInput
   */
  customerSuccessAssignedTo?: string | null;
  /**
   *
   * @type {number}
   * @memberof EditCompanyInput
   */
  estimatedMonthlyFreightSpend?: number | null;
  /**
   *
   * @type {number}
   * @memberof EditCompanyInput
   */
  monthlyLtlCaptureEstimate?: number | null;
  /**
   *
   * @type {number}
   * @memberof EditCompanyInput
   */
  estimatedMonthlyShipments?: number | null;
}

/**
 * Check if a given object implements the EditCompanyInput interface.
 */
export function instanceOfEditCompanyInput(
  value: object,
): value is EditCompanyInput {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  if (!("phone" in value) || value["phone"] === undefined) return false;
  if (
    !("billingAddressLine" in value) ||
    value["billingAddressLine"] === undefined
  )
    return false;
  if (!("billingCity" in value) || value["billingCity"] === undefined)
    return false;
  if (!("billingState" in value) || value["billingState"] === undefined)
    return false;
  if (
    !("billingPostalCode" in value) ||
    value["billingPostalCode"] === undefined
  )
    return false;
  if (!("leadSource" in value) || value["leadSource"] === undefined)
    return false;
  if (
    !("associatedProfessionalDomain" in value) ||
    value["associatedProfessionalDomain"] === undefined
  )
    return false;
  if (
    !("knownGroupEmailAddresses" in value) ||
    value["knownGroupEmailAddresses"] === undefined
  )
    return false;
  if (
    !("invoiceAuditNotes" in value) ||
    value["invoiceAuditNotes"] === undefined
  )
    return false;
  if (!("apiAccessEnabled" in value) || value["apiAccessEnabled"] === undefined)
    return false;
  if (
    !("addLabelsToCompany" in value) ||
    value["addLabelsToCompany"] === undefined
  )
    return false;
  return true;
}

export function EditCompanyInputFromJSON(json: any): EditCompanyInput {
  return EditCompanyInputFromJSONTyped(json, false);
}

export function EditCompanyInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EditCompanyInput {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    companyName: json["companyName"],
    phone: json["phone"],
    billingAddressLine: json["billingAddressLine"],
    billingCity: json["billingCity"],
    billingState: json["billingState"],
    billingCountry:
      json["billingCountry"] == null
        ? undefined
        : CountryCodeFromJSON(json["billingCountry"]),
    billingPostalCode: json["billingPostalCode"],
    leadSource: json["leadSource"],
    leadSourceNote:
      json["leadSourceNote"] == null ? undefined : json["leadSourceNote"],
    temperature:
      json["temperature"] == null
        ? undefined
        : CompanyTemperatureFromJSON(json["temperature"]),
    shipmentFrequency:
      json["shipmentFrequency"] == null ? undefined : json["shipmentFrequency"],
    shipmentFrequencyNote:
      json["shipmentFrequencyNote"] == null
        ? undefined
        : json["shipmentFrequencyNote"],
    associatedProfessionalDomain: json["associatedProfessionalDomain"],
    knownGroupEmailAddresses: json["knownGroupEmailAddresses"],
    invoiceAuditNotes: json["invoiceAuditNotes"],
    apiAccessEnabled: json["apiAccessEnabled"],
    addLabelsToCompany: AddLabelsToCompanyFromJSON(json["addLabelsToCompany"]),
    assignedTo: json["assignedTo"] == null ? undefined : json["assignedTo"],
    customerSuccessAssignedTo:
      json["customerSuccessAssignedTo"] == null
        ? undefined
        : json["customerSuccessAssignedTo"],
    estimatedMonthlyFreightSpend:
      json["estimatedMonthlyFreightSpend"] == null
        ? undefined
        : json["estimatedMonthlyFreightSpend"],
    monthlyLtlCaptureEstimate:
      json["monthlyLtlCaptureEstimate"] == null
        ? undefined
        : json["monthlyLtlCaptureEstimate"],
    estimatedMonthlyShipments:
      json["estimatedMonthlyShipments"] == null
        ? undefined
        : json["estimatedMonthlyShipments"],
  };
}

export function EditCompanyInputToJSON(json: any): EditCompanyInput {
  return EditCompanyInputToJSONTyped(json, false);
}

export function EditCompanyInputToJSONTyped(
  value?: EditCompanyInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    companyName: value["companyName"],
    phone: value["phone"],
    billingAddressLine: value["billingAddressLine"],
    billingCity: value["billingCity"],
    billingState: value["billingState"],
    billingCountry: CountryCodeToJSON(value["billingCountry"]),
    billingPostalCode: value["billingPostalCode"],
    leadSource: value["leadSource"],
    leadSourceNote: value["leadSourceNote"],
    temperature: CompanyTemperatureToJSON(value["temperature"]),
    shipmentFrequency: value["shipmentFrequency"],
    shipmentFrequencyNote: value["shipmentFrequencyNote"],
    associatedProfessionalDomain: value["associatedProfessionalDomain"],
    knownGroupEmailAddresses: value["knownGroupEmailAddresses"],
    invoiceAuditNotes: value["invoiceAuditNotes"],
    apiAccessEnabled: value["apiAccessEnabled"],
    addLabelsToCompany: AddLabelsToCompanyToJSON(value["addLabelsToCompany"]),
    assignedTo: value["assignedTo"],
    customerSuccessAssignedTo: value["customerSuccessAssignedTo"],
    estimatedMonthlyFreightSpend: value["estimatedMonthlyFreightSpend"],
    monthlyLtlCaptureEstimate: value["monthlyLtlCaptureEstimate"],
    estimatedMonthlyShipments: value["estimatedMonthlyShipments"],
  };
}
